import { z } from "zod";

export const purchaseTypeSchema = z.enum(["new_purchase", "renewal"]);
export type PurchaseType = z.infer<typeof purchaseTypeSchema>;

export const termLengthSchema = z.enum(["12", "24", "36"]);
export type TermLength = z.infer<typeof termLengthSchema>;

const productSchema = z.object({
  productId: z.string(),
  dimensions: z.record(z.string(), z.union([z.string(), z.number()])),
  editing: z.boolean(),
});
export type Product = z.infer<typeof productSchema>;

export const answersSchema = z
  .intersection(
    productSchema,
    z.object({
      nameWithFamily: z.string().nullish(),
      dimensionsDetail: z.string().nullish(),
    }),
  )
  .array();
export type Answers = z.infer<typeof answersSchema>;

export const estimateFormSchema = z.object({
  companyId: z.string(),
  purchaseType: purchaseTypeSchema,
  termLength: termLengthSchema,
  products: z.array(productSchema),
});
export type EstimateForm = z.infer<typeof estimateFormSchema>;

export const newEstimateSchema = z.object({
  ...estimateFormSchema.shape,
  previousScopeId: z.string().nullish(),
  companyName: z.string(),
  answers: answersSchema.nullish(),
});

export type NewEstimate = z.infer<typeof newEstimateSchema>;
